var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "scout-form",
    {
      attrs: {
        "is-modified": !!_vm.isReviewSaved,
        half: _vm.half,
        label: "行動ターゲティング",
      },
    },
    [
      _c("div", { staticClass: "boss-layout boss-layout-start" }, [
        _c(
          "label",
          {
            staticClass: "boss-checkbox",
            attrs: { "data-test": "is-review-saved" },
          },
          [
            _c("input", {
              staticClass: "boss-input-checkbox",
              attrs: { type: "checkbox" },
              domProps: { checked: _vm.isReviewSaved },
              on: {
                change: function ($event) {
                  return _vm.$emit(
                    "update:isReviewSaved",
                    $event.target.checked
                  )
                },
              },
            }),
            _vm._v("この求人を気になるリストに保存している会員\n    "),
          ]
        ),
      ]),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }